import { DolsStatus, type ResidentItem } from '@lmc/ts-common'
import dayjs from 'dayjs'

export const shouldShowDolsBadge = (
  resident: ResidentItem,
  dolsModsAlignment: boolean
) => {
  const dolsStartDate = resident.dolsStartDate
    ? dayjs(resident.dolsStartDate)
    : null
  const dolsEndDate = resident.dolsEndDate ? dayjs(resident.dolsEndDate) : null
  const dolsEndDateValid = !dolsEndDate || dolsEndDate.isAfter(dayjs())
  const dolsStartDateValid = !dolsStartDate || dolsStartDate.isBefore(dayjs())

  const displayDolsBadge = dolsModsAlignment
    ? resident.dolsStatus === DolsStatus.authorised &&
      dolsEndDateValid &&
      dolsStartDateValid
    : resident.dols && dolsEndDateValid && dolsStartDateValid
  return displayDolsBadge
}
